export default [
  {
    testDescription: 'Default',
  },
  {
    testDescription: 'Without name',
    name: null,
  },
  {
    testDescription: 'Without description',
    description: null,
  },
  {
    testDescription: 'Without servicePortal',
    servicePortal: null,
  },
  {
    testDescription: 'Without name + servicePortal',
    name: null,
    servicePortal: null,
  },
  {
    testDescription: 'Without optionals',
    description: null,
    servicePortal: null,
    bookedInstances: 0,
    maxInstances: null,
    promotionTypeId: null,
  },
  {
    testDescription: 'promotionType = 2',
    promotionTypeId: 2,
  },
  {
    testDescription: 'Max instances reached',
    bookedInstances: 5,
    maxInstances: 5,
  },
  {
    testDescription: 'isExclusionGroupConflict = true',
    isExclusionGroupConflict: true,
    excludedBy: [
      {
        productName: 'Xyz',
        subscriptionTemplateId: '123456',
        uniqueSubscriptionId: '99999',
      },
    ],
  },
  {
    testDescription: 'Free of charge',
    price: {
      chargingIntervalFactor: 1,
      chargingIntervalOverrideText: null,
      chargingIntervalUnit: 3,
      isExact: true,
      minimumCommitmentPeriodFactor: null,
      minimumCommitmentPeriodUnit: null,
      priceDisplay: null,
      promotion: {
        durationFactor: 1,
        durationUnit: 3,
        priceDisplay: null,
        promotionEnd: null,
        setupPrice: null,
      },
      setupPrice: null,
    },
  },
  {
    testDescription: 'Free of charge + MinimumCommitmentPeriod',
    price: {
      chargingIntervalFactor: 1,
      chargingIntervalOverrideText: null,
      chargingIntervalUnit: 3,
      isExact: true,
      minimumCommitmentPeriodFactor: 24,
      minimumCommitmentPeriodUnit: 3,
      priceDisplay: null,
      promotion: {
        durationFactor: 1,
        durationUnit: 3,
        priceDisplay: null,
        promotionEnd: null,
        setupPrice: null,
      },
      setupPrice: null,
    },
  },
  {
    testDescription: 'Promotion Price Free of charge',
    price: {
      promotion: {
        amount: 0,
        currency: 'EUR',
        priceDisplay: null,
        value: '0',
      },
    },
  },
  {
    testDescription: 'No Price Promotion',
    price: {
      promotion: null,
    },
  },
  {
    testDescription: 'No Price Promotion durationFactor (and no Promotion.setupPrice)',
    price: {
      promotion: {
        durationFactor: null,
        promotionEnd: '31.12.2019',
        setupPrice: null,
      },
    },
  },
  {
    testDescription: 'No Price Promotion durationFactor (BUT WITH Promotion.setupPrice)',
    price: {
      promotion: {
        durationFactor: null,
        promotionEnd: '31.12.2019',
      },
    },
  },
  {
    testDescription: 'PromotionEnd (and durationFactor: should override!)',
    price: {
      promotion: {
        promotionEnd: '31.12.2019',
      },
    },
  },
  {
    testDescription: 'Price Promotion durationFactor = 3',
    price: {
      promotion: {
        durationFactor: 3,
      },
    },
  },
  {
    testDescription: 'Price Promotion durationFactor = 15, chargingIntervalFactor = 3, chargingIntervalUnit = 2 (Days), promotion unit = 6 (Minutes)',
    price: {
      chargingIntervalUnit: 1,
      chargingIntervalFactor: 3,
      promotion: {
        durationFactor: 15,
        durationUnit: 6,
      },
    },
  },
  {
    testDescription: 'No Promotion setupPrice',
    price: {
      promotion: {
        setupPrice: null,
      },
    },
  },
  {
    testDescription: 'No setupPrice',
    price: {
      setupPrice: null,
    },
  },
  {
    testDescription: 'No setupPrice and no Promotion setupPrice',
    price: {
      setupPrice: null,
      promotion: {
        setupPrice: null,
      },
    },
  },
  {
    testDescription: 'No setupPrice and no Promotion',
    price: {
      setupPrice: null,
      promotion: null,
    },
  },
  {
    testDescription: 'minimumCommitmentPeriodFactor = 1',
    price: {
      minimumCommitmentPeriodFactor: 1,
    },
  },
  {
    testDescription: 'minimumCommitmentPeriodFactor = 0',
    price: {
      minimumCommitmentPeriodFactor: 0,
    },
  },
  {
    testDescription: 'minimumCommitmentPeriodUnit = 1',
    price: {
      minimumCommitmentPeriodUnit: 1,
    },
  },
];
